import {BasicEntity} from '../../framework/message/BasicEntity';

export class Delegation extends BasicEntity {
endDate: number | null;
from: string;
startDate: number | null;
to: string;
}

